import { HomeRouterLayout } from "@spa/app/layouts/HomeRouterLayout";
import { withSuspense } from "@spa/app/routes/withSuspense";
import type { RouteObject } from "react-router-dom";

const LibraryPage = withSuspense(
  () => import("@dust-tt/front/components/pages/library/LibraryPage"),
  "LibraryPage"
);

const DashboardsPage = withSuspense(
  () => import("@dust-tt/front/components/pages/dashboards/DashboardsPage"),
  "DashboardsPage"
);

const LiveDocPage = withSuspense(
  () => import("@dust-tt/front/components/pages/live/LiveDocPage"),
  "LiveDocPage"
);

export const libraryRoutes: RouteObject[] = [
  {
    element: <HomeRouterLayout />,
    children: [
      { path: "library", element: <LibraryPage /> },
      { path: "library/dashboards", element: <DashboardsPage /> },
      { path: "library/dashboards/:fileId", element: <DashboardsPage /> },
      { path: "library/:fileId", element: <LibraryPage /> },
      { path: "live/:docId", element: <LiveDocPage /> },
    ],
  },
];
